export const CARGAR_PROVEEDOR = 'CARGAR_PROVEEDOR';